export default {
    assignees: (state) => state.assignees || {}
};
